<app-modal-header-common title="Create Audit Template" [dialogRef]="dialogRef">
</app-modal-header-common>
<div class="plan-form">
  <p *ngIf="isTemplateFileRequired" class="uploaded-file">
    Template file - {{ this.data.uploadedFile.name }}
  </p>
  <form [formGroup]="templateForm">
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Title</mat-label>
      <input matInput formControlName="title" required />
    </mat-form-field>
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Description</mat-label>
      <input matInput formControlName="description" />
    </mat-form-field>
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Frequency</mat-label>
      <mat-select formControlName="frequency" required>
        <mat-option *ngFor="let option of frequencies" [value]="option.id">
          {{ option.display_name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Type</mat-label>
      <mat-select formControlName="type" required>
        <mat-option *ngFor="let option of auditTypes" [value]="option.id">
          {{ option.display_name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Applicability</mat-label>
      <input matInput formControlName="applicability" />
    </mat-form-field>
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Focus Area</mat-label>
      <input matInput formControlName="focus_area" />
    </mat-form-field>
    <mat-form-field
      class="w-100"
      appearance="outline"
      *ngIf="!isTemplateFileRequired"
    >
      <mat-label>Response Options<span class="required-asterisk">*</span></mat-label>
      <mat-chip-list #respChipList aria-label="Response selection">
        <mat-chip
          *ngFor="let res of selectedResponses; let i = index"
          [selectable]="true"
          [removable]="true"
          (removed)="removeResponse(i)"
        >
          {{ res }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>

        <input
          type="text"
          placeholder="Select response..."
          readonly
          [matChipInputFor]="respChipList"
          [matAutocomplete]="autoResp"
          #respTrigger="matAutocompleteTrigger"
          (click)="respTrigger.openPanel()"
        />
      </mat-chip-list>

      <mat-autocomplete
        #autoResp="matAutocomplete"
        (optionSelected)="addResponse($event.option.value)"
      >
        <mat-option
          *ngFor="let option of responseOptions"
          [value]="option.name"
        >
          {{ option.name }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Internal assessor</mat-label>
      <mat-select formControlName="internal_assessor">
        <mat-option *ngFor="let option of usersList" [value]="option.id">
          {{ option.first_name + " " + option.last_name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-slide-toggle class="mb-3" formControlName="is_external_assessment"
      >Is external assessment</mat-slide-toggle
    >
    <mat-form-field
      class="w-100"
      appearance="outline"
      *ngIf="templateForm.get('is_external_assessment')?.value"
    >
      <mat-label>External assessor</mat-label>
      <input matInput formControlName="external_assessor" />
    </mat-form-field>
    <app-tag
      [noIds]="true"
      [tagsIds]="assessmentTags"
      (childTags)="getChildTags($event)"
    ></app-tag>
    <div style="display: flex; justify-content: end" class="mt-3">
      <button mat-button mat-dialog-close color="primary" class="mx-1">
        Close
      </button>
      <button
        mat-raised-button
        color="primary"
        class="templ-btn"
        (click)="createAssessment()"
        [disabled]="templateForm.invalid"
      >
        Create
      </button>
    </div>
  </form>
</div>
